<script lang="ts" module>
  import { type AISuggestion } from '@/teoCore/text/AIHandler';
  import InfoCard from '@/ui/elements/card/InfoCard.svelte';

  import AiContentHeader, { type AIContentHeaderProps } from './AIContentHeader.svelte';
  import AiPromt, { type AIStyleProps } from './AIStyle.svelte';
  import AiSuggestion, { type AISuggestionProps } from './AISuggestion.svelte';

  interface AdditionalProps {
    aiDescription?: string;
  }

  export type AIContainerProps = AIStyleProps &
    Omit<AIContentHeaderProps, 'pages' | 'tpi' | 'current'> &
    Omit<AISuggestionProps, 'aiSuggestions' | 'showSuggestion'> & {
      aiSuggestions: AISuggestion[];
    } & AdditionalProps;
</script>

<script lang="ts">
  let { ...props }: AIContainerProps = $props();
  let curPage = $state(0);
</script>

<div class="grid gap-3">
  {#if props.aiDescription}
    <InfoCard shortText={props.aiDescription} dimension="white"></InfoCard>
    <hr class="border-t-c-divider" />
  {/if}
  {#if props.aiSuggestions.length > 0}
    <AiContentHeader
      tpi={props.aiSuggestions[curPage]?.tpi ?? 0}
      pages={props.aiSuggestions.length}
      bind:current={curPage}
    ></AiContentHeader>

    <AiSuggestion
      bind:aiSuggestions={props.aiSuggestions}
      bind:showSuggestion={curPage}
      finalStateMessage={props.finalStateMessage}
      onInsertClick={props.onInsertClick}
    ></AiSuggestion>
    <hr class="border-t-c-divider" />
  {/if}
  <AiPromt
    aiStyleItems={props.aiStyleItems}
    onAIStyleClick={props.onAIStyleClick}
    aiStyleLoading={props.aiStyleLoading}
    aiStyleDisabled={props.aiStyleDisabled}
    aiStyleLabel={props.aiStyleLabel}
    aiStyleTooltip={props.aiStyleTooltip}
  ></AiPromt>
</div>
